export default __webpack_public_path__ + "static/media/linkStore.1fb3b040.svg";